export default "__VITE_ASSET__u6RPM15A__"